<template>
  <div class="id-form">
    <div v-if="!gradings.length">
      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
        <p>
          查询报告
        </p>
        <el-form-item prop="id">
          <el-input type="text" placeholder="请输入88ID" v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="loading" style="width: 100%" type="primary" @click="submitForm('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <el-button :loading="loading" style="width: 100%" type="primary" @click="back">返回</el-button>
      <el-table
        :data="gradings"
        style="width: 100%">
      <el-table-column prop="createdAt" :label="$t('default.uploadText')" width="200px">
        <template slot-scope="scope">
          {{getDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="openReport(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
export default {
  data () {
    return {
      userName: '',
      passsword: '',
      loading: false,
      gradings: [],
      form: {
        id: ''
      },
      rules: {
        id: [
          { required: true, message: 'id不得为空', trigger: 'blur' }
        ]
      }
    }
  },
  beforeCreate: function () {
    document.title = '查询报告'
  },
  mounted: function () {
  },
  methods: {
    back () {
      this.gradings = []
    },
    openReport (row) {
      const lang = localStorage.getItem('lang') || 'tc'
      let url = `/report.html#/?mode=ai_out&id=${row._id}&from=doctor&lang=${lang}`
      if (row.reportType === 'vessel') {
        url = `/report.html#/vascular?mode=ai_out&id=${row._id}&from=doctor&lang=${lang}`
      }
      window.location.href = (url)
    },
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    submitForm (formName) {
      if (this.form.id.length < 6) {
        return this.$notify({
          title: 'ID格式错误，请确认ID输入无误',
          type: 'warning'
        })
      }
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          axios.get(`${window.config.fcDomain}/api/gradings/id?organizationId=65b23697bdca81000429d10f&patientId=${this.form.id}`).then((res) => {
            this.loading = false
            const data = res.data.data
            console.log(data)
            if (data.gradings.length < 1) {
              that.$notify({
                title: '没有查找到报告，请确认ID输入无误',
                type: 'warning'
              })
            }
            if (data.gradings.length === 1) {
              return this.openReport(data.gradings[0])
            }
            this.gradings = data.gradings
          })
            .catch(function (error) {
              that.loading = false
              if (error.response) {
                console.log(error.response)
                if (error.response.status === 401) {
                  that.$notify({
                    title: '请填写88ID',
                    type: 'warning'
                  })
                } else if (error.response.status === 404) {
                  that.$notify({
                    title: '',
                    type: 'warning'
                  })
                }
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style>
.id-form {
  padding-top: 50px;
  padding: 50px 20px;
}
</style>
